export default __webpack_public_path__ + "static/media/ict.783f662a.png";